import { JwtPayload } from 'jwt-decode';
import { AUTH_STATE_KEY, AuthState } from './auth-reducer';
import { AUTH_USER_ROLE } from './auth-constant';

export enum AUTH_ACTION_TYPE {
  SET_STATE = 'AUTH/SET_STATE',
  LOGIN_REQUEST = 'AUTH/LOGIN_REQUEST',
  LOGIN_SUCCESS = 'AUTH/LOGIN_SUCCESS',
  LOGIN_ERROR = 'AUTH/LOGIN_ERROR',
  LOGOUT = 'AUTH/LOGOUT',
  CHECK_AUTHORIZATION = 'AUTH/CHECK_AUTHORIZATION',
}

export type SetAuthStateAction<KeyName extends keyof AuthState> = {
  type: AUTH_ACTION_TYPE.SET_STATE;
  payload: { key: KeyName, value: AuthState[KeyName] };
};

export type LoginRequestAction = {
  type: AUTH_ACTION_TYPE.LOGIN_REQUEST;
};

export type LoginSuccessAction = {
  type: AUTH_ACTION_TYPE.LOGIN_SUCCESS;
  payload: { data: any };
};

export type LoginErrorAction = {
  type: AUTH_ACTION_TYPE.LOGIN_ERROR;
};

export type LogoutAction = {
  type: AUTH_ACTION_TYPE.LOGOUT;
};

export type CheckAuthorizationAction = {
  type: AUTH_ACTION_TYPE.CHECK_AUTHORIZATION;
};

export type AuthActions = SetAuthStateAction<AUTH_STATE_KEY> | LoginRequestAction | LoginSuccessAction | LoginErrorAction |
  LogoutAction | CheckAuthorizationAction;

export type LoginData = {
  username : string;
  password : string;
}

export type AuthToken = {
  accessToken: string;
  refreshToken?: string;
  idToken: string;
};

export type AuthChallenge = {
  name: string;
  session: string;
  refCode?: string;
};

export type SignInRespData = {
  token?: AuthToken;
  challenge?: AuthChallenge;
};

export interface TokenPayload extends JwtPayload {
  'custom:shopId': number;
  'custom:merchantRole'?: AUTH_USER_ROLE;
  'cognito:username': string;
  'custom:merchantId': string;
  email: string;
  email_verified?: boolean;
  // NOTE: phone_number only users that verified phone number has this field.
  phone_number?: string;
}